<open-search [contentBlockData]="content"
             searchId="open"></open-search>
